import eventHub from '@/scripts/eventHub';
import {
  AnimatedSprite,
  Loader,
  Point,
  Sprite,
  Texture,
} from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';
import Actor from './Actor';

class Wave extends Actor {
  constructor(parent, player, renderer) {
    super(parent);
    this.player = player;
    this.speed = state.initialSpeed;
    this.speedDifference = 0;

    this.container = new Sprite();
    this.spriteBack = new AnimatedSprite(
      Object.values(
        Loader.shared.resources['sprites/WAVE'].spritesheet.textures,
      ),
    );
    this.spriteMid = new AnimatedSprite(
      Object.values(
        Loader.shared.resources['sprites/WAVE'].spritesheet.textures,
      ),
    );
    this.spriteFore = new AnimatedSprite(
      Object.values(
        Loader.shared.resources['sprites/WAVE'].spritesheet.textures,
      ),
    );
    const fillerLoopTextures = [
      ...Object.values(Loader.shared.resources['sprites/WAVE_LOOP_1'].textures),
      ...Object.values(Loader.shared.resources['sprites/WAVE_LOOP_2'].textures),
    ];
    fillerLoopTextures.forEach((t) => { renderer.plugins.prepare.upload(t); });
    this.fillerLoop = new AnimatedSprite(fillerLoopTextures);
    this.fillerLoop.animationSpeed = 0.4;
    this.fillerLoop.loop = true;
    this.fillerLoop.play();

    this.spriteBack.animationSpeed = 0.5;
    this.spriteBack.tint = 0x806619;
    this.spriteMid.animationSpeed = 0.5;
    this.spriteMid.tint = 0xCBAD00;
    this.spriteFore.animationSpeed = 0.5;
    this.filler = new Sprite(Texture.WHITE);
    this.filler.tint = 0xFFDF00;

    this.frameHandler = () => { this.frame(); };

    this.resize();

    this.container.addChild(this.filler);
    this.container.addChild(this.fillerLoop);
    this.container.addChild(this.spriteBack);
    this.container.addChild(this.spriteMid);
    this.container.addChild(this.spriteFore);
    this.parent.addChild(this.container);
  }

  resize() {
    this.filler.anchor = new Point(0, 1);
    this.fillerLoop.anchor = new Point(0, 1);
    this.filler.height = vars.layout.FRAME_HEIGHT;
    this.filler.width = vars.layout.FRAME_WIDTH;
    this.filler.position.y = -200;
    this.fillerLoop.position.y = -200;
    this.spriteBack.position.y = -190;
    this.spriteMid.position.y = -195;
    this.spriteFore.position.y = -202; // Fix the 1px antialiasing

    this.container.zIndex = 4;
  }

  reset() {
    this.container.position.y = 0;
    this.filler.position.y = -200;
    this.spriteBack.position.y = -190;
    this.spriteMid.position.y = -195;
    this.spriteFore.position.y = -200;
    this.speedDifference = 0;
  }

  startMove() {
    ticker.add(this.frameHandler);
    this.spriteBack.play();
    this.spriteMid.play();
    this.spriteFore.play();
  }

  frame() {
    this.speedDifference -= this.speed - state.speed;
    this.container.position.y = 0 - this.speedDifference;

    // this.spriteBack.position.x = 10 + (((vars.layout.FRAME_WIDTH / 2) - this.player.sprite.position.x) * 0.1);
    // this.spriteMid.position.x = 5 + (((vars.layout.FRAME_WIDTH / 2) - this.player.sprite.position.x) * 0.05);
    this.spriteBack.position.x = ((vars.layout.FRAME_WIDTH / 2) - this.player.sprite.position.x) * 0.1;
    this.spriteMid.position.x = ((vars.layout.FRAME_WIDTH / 2) - this.player.sprite.position.x) * 0.05;

    // Todo check wave height
    const { top } = this.spriteFore.getBounds();
    if (top > this.player.sprite.position.y) {
      state.gameover = true;
      eventHub.$emit('gameover');
    }
  }

  gameover() {
    ticker.remove(this.frameHandler);
  }
}

export default Wave;
